// extracted by mini-css-extract-plugin
export default {"legalText":"Chat-module__legalText--wsTEU"};